import React from 'react';
import ExpandingInfo from './components/calculators-layout/ExpandingInfo';
import CalculatorForm from './components/calculators-layout/CalculatorForm';
import CalculatorLayout from './components/calculators-layout/CalculatorLayout';
import InputWithLabel from '../LoanApplication/components/commons/InputWithLabel';
import {ToggleButton, ToggleButtonGroup} from 'react-bootstrap';
import CalculatorResultCard from './components/calculators-layout/CalculatorResultCard';
import CalculatorCallToActionCard from './components/calculators-layout/CalculatorCallToActionCard';
import CalculatorCostsBreakdown from './components/calculators-layout/CalculatorCostsBreakdown';
import {postSetupCost, getStampDutyResult} from './api';
import CalculatorAssumptions from './components/calculators-layout/CalculatorAssumptions';
import StampDutyAssumptionContent from './AssumptionBoxContent/StampDutyAssumptionContent';

class StampDutyCalculator extends React.Component {
  state = {
    propertyPrice: 900000,
    state: 'nsw',
    loanTarget: 'own_home',
    firstHomeBuyer: true,
    status: '2',
    errors: {},
    results: {
      totalSetupCostLabel: 0,
      stampDutyLabel: 0,
      mortgageRegistrationLabel: 0,
      transferFeeLabel: 0,
    },
  };

  availableStates  = [
    { value: "act", label: "ACT" },
    { value: "nsw", label: "NSW" },
    { value: "nt", label: "NT" },
    { value: "qld", label: "QLD" },
    { value: "sa", label: "SA" },
    { value: "tas", label: "TAS" },
    { value: "vic", label: "VIC" },
    { value: "wa", label: "WA" }
  ];

  availableStatus  = [
    { value: "2", label: "Existing" },
    { value: "1", label: "New" },
    { value: "3", label: "Vacant land" },
  ];

  onCalculationSuccess = (response) => {
    this.setState({results: response.data})
  }

  onCalculationFailure = ({ response }) => {
    let errors = response.data.errors

    let swalTitle = I18n.t('calculators.generic_error.title')
    let swalText = I18n.t('calculators.generic_error.description')

    if ((response.status) == 422) {
      swalTitle = I18n.t('calculators.generic_error.title')
      swalText = response.data.errors
    }

    swal({
      title: swalTitle,
      text: swalText,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      confirmButtonColor: "#10c98f",
    })
  }

  onCalculationSubmit = async () => {
    let data = {
      setup_costs: {...this.state},
    }

    const result = await getStampDutyResult(this.state);
    this.setState({
      results: {
        totalSetupCostLabel: result.TotalDuty,
        stampDutyLabel: result.StampDuty,
        mortgageRegistrationLabel: result.RegistrationFee,
        transferFeeLabel: result.TransferFee,
      }
    })
    /*
      postSetupCost(data,
        this.onCalculationSuccess,
        this.onCalculationFailure
      )
    */
  }
  
  componentDidMount = () => {
    this.onCalculationSubmit()
  };
  
  expandingLead = (
    <React.Fragment>
      <p>Stamp duty (transfer duty) is a tax levied by state and territory governments in relation to certain transactions such as purchase of your own home or a holiday home, investment property or vacant land. </p>
      <p>You can use our stamp duty calculator to estimate your government charges across all states in Australia.</p>
    </React.Fragment>
  );
  
  expandingInfoContent = (
    <React.Fragment>
      <p>The cost of stamp duty is determined by a several factors:</p>
      <ul>
        <li>Property or vacant land purchase price</li>
        <li>The location of the property as different tax applies for each state and territory government</li>
        <li>Whether you are first home buyer or not</li>
        <li>The type of property - owner-occupied or an investment</li>
      </ul>
      <p>Once you enter the details below, you will receive an estimate of your stamp (transfer) duty. </p>
      <p>You might be eligible for further grants or concessions if you are a First Home Buyer - you should refer to your state or territory government authority to understand your eligibility.</p>
    </React.Fragment>
  );
  
  calculatorForm() {
    const { propertyPrice, state, errors, status } = this.state;
    return (
      <React.Fragment>
        <div className="numeric-input">
          <InputWithLabel
            label='Property price'
            type='currency'
            defaultValue={propertyPrice}
            errorMessage={errors['propertyPrice']}
            onChange={(value) => this.setState({propertyPrice: value})}
          />
        </div>
        <div className="stamp-duty-calculator__state-select select-input">
          <InputWithLabel type='select'
                          label='State/Territory'
                          defaultValue={state}
                          options={ this.availableStates }
                          onChange={(value) => {this.setState({state: value })}} />
        </div>
        <div className="stamp-duty-calculator__state-select select-input">
          <InputWithLabel type='select'
                          label="Property type"
                          defaultValue={status}
                          options={ this.availableStatus }
                          onChange={(value) => {this.setState({status: value })}} />
        </div>
        <div className="stamp-duty-calculator__toggle-group calculator-toggle-group double">
          <ToggleButtonGroup className='btn-group btn-group-radio-tabs btn-group-toggle btn-group-sm d-flex'
                             type="radio"
                             name="options"
                             defaultValue={'own_home'}
                             onChange={ (value) => { this.setState({ loanTarget: value }) } }>
            <ToggleButton className='btn onboarding-form' value="own_home">I will live there</ToggleButton>
            <ToggleButton className='btn onboarding-form' value="investment">I am investing</ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className="stamp-duty-calculator__toggle-group calculator-toggle-group double">
          <ToggleButtonGroup className='btn-group btn-group-radio-tabs btn-group-toggle btn-group-sm d-flex'
                             type="radio"
                             name="options"
                             defaultValue={true}
                             onChange={ (value) => { this.setState({ firstHomeBuyer: value }) } }>
            <ToggleButton className='btn onboarding-form' value={true}>First home</ToggleButton>
            <ToggleButton className='btn onboarding-form' value={false}>Next home</ToggleButton>
          </ToggleButtonGroup>
        </div>
      </React.Fragment>
    )
  }
  
  resultsColumn() {
    const {results} = this.state
    const {
      totalSetupCostLabel,
      stampDutyLabel,
      mortgageRegistrationLabel,
      transferFeeLabel,
    } = results
    return results ? <div>
      <CalculatorResultCard
        caption='Your estimated stamp duty cost is:'
        figure={totalSetupCostLabel}
      />
      <CalculatorCallToActionCard>
        <div className='stamp-duty-calculator__cta'>
          <p className='stamp-duty-calculator__cta-text regular-cta'>Ready to start?</p>
        </div>
      </CalculatorCallToActionCard>
      <CalculatorCostsBreakdown
        costs = {[
          {
            costText: 'Stamp duty',
            costAmount: stampDutyLabel,
          },
          {
            costText: 'Mortgage registration',
            costAmount: mortgageRegistrationLabel,
          },
          {
            costText: 'Transfer fee',
            costAmount: transferFeeLabel,
          }
        ]}
        totalCost={{
          costText: 'Total cost',
          costAmount: totalSetupCostLabel,
        }}
      />
    </div>: null;
  }
  
  render() {
    return (
      <div className="stamp-duty-calculator">
        <CalculatorLayout
          infoRow={<ExpandingInfo lead={this.expandingLead}>{this.expandingInfoContent}</ExpandingInfo>}
          formColumn={
            <React.Fragment>
              <CalculatorForm handleSubmit={this.onCalculationSubmit}>{this.calculatorForm()}</CalculatorForm>
            </React.Fragment>
          }
          resultsColumn={this.resultsColumn()}
        >
          <CalculatorAssumptions assumptionBoxContents={<StampDutyAssumptionContent />} />
        </CalculatorLayout>
      </div>
    );
  }
}

export default StampDutyCalculator;
